/* eslint-disable no-console */
import {
  Container,
  MetadataTitle,
  MetadataDescription,
  MetadataAtributes,
  Skeleton,
  PanelWrapper,
  MetadataItemWrap,
} from './styles';

import Icons from '@icons';
import Icon from '@map/components/Icons';
import dot from 'dot-object';
import { useSnackbar } from 'notistack';
/**
 * PropTypes é um mecanismo utilizado para garantir que os 
 * componentes usem o tipo de dados correto e passem os dados corretos
 */
import PropTypes from 'prop-types';
/**
 * useEffect é um hook que permite executar efeitos colaterais em
 * seus componentes, por exemplo: buscar dados, atualizar diretamente
 * o DOM e cronômetros, ele aceita dois argumentos o segundo é opcional
 * 
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 * 
 * useRef permite que persista valores entre renderizações, ele pode
 * ser usado para armazenar um valor mutável que não causa uma nova
 * renderização quando atualizado e pode ser usado para acessar di-
 * retamente um elemento do DOM.
 */
import { useEffect, useState, useRef } from 'react';

/**
 * Componente de visualização simplificada de metadados de uma camada.
 * Utilizado em diversos lugare no sistema, tanto no Administrativo como no Mapa.
 */
const MetadataView = ({
  hasMetadata,
  layerMetadata,
  metadataLink,
  layerName,
  layerResume,
  serviceLink,
  avaliableWMSServiceLink,
  avaliableWFSServiceLink,
  canShowLinkService,
  onlyContent,
  descriptionOverflow,
}) => {
  const [metadataInfo, setMetadataInfo] = useState({
    title: null,
    description: null,
    scale: null,
    date: {
      type: null,
      date: null,
    },
    metadataLink,
    serviceLink,
    source: null,
  });
  const [isShowing, setIsShowing] = useState(true);
  const [isLoadingData, setIsLoadingData] = useState(false);

  useEffect(() => {
    setIsLoadingData(true)
    let title;
    let description;
    let scale;
    let date;
    let dateType;
    let source;
    
    const metadataStr = JSON.stringify(layerMetadata);

    const isGmd = metadataStr.includes('gmd:');

    const metadataPath = !isGmd ? {
      title:
        'mdb:identificationInfo.mri:MD_DataIdentification.mri:citation.cit:CI_Citation.cit:title.gco:CharacterString',
      description:
        'mdb:identificationInfo.mri:MD_DataIdentification.mri:abstract.gco:CharacterString',
      scale:
        'mdb:spatialRepresentationInfo.msr:MD_VectorSpatialRepresentation.msr:geometricObjects.msr:MD_GeometricObjects.msr:geometricObjectCount.gco:Integer', // Ajuste conforme a escala/resolução real do seu metadado
      date: {
        type:
          'mdb:identificationInfo.mri:MD_DataIdentification.mri:citation.cit:CI_Citation.cit:date.cit:CI_Date.cit:dateType.cit:CI_DateTypeCode.@attributes.codeListValue',
        dateString:
          'mdb:identificationInfo.mri:MD_DataIdentification.mri:citation.cit:CI_Citation.cit:date.cit:CI_Date.cit:date.gco:CharacterString',
        dateDateTime:
          'mdb:identificationInfo.mri:MD_DataIdentification.mri:citation.cit:CI_Citation.cit:date.cit:CI_Date.cit:date.gco:DateTime',
        dateDate:
          'mdb:identificationInfo.mri:MD_DataIdentification.mri:citation.cit:CI_Citation.cit:date.cit:CI_Date.cit:date.gco:Date',
      },
      serviceLink:
        'mdb:distributionInfo.mrd:MD_Distribution.mrd:transferOptions.mrd:MD_DigitalTransferOptions.mrd:onLine.0.cit:CI_OnlineResource.cit:linkage.gco:CharacterString',
      serviceType:
        'mdb:distributionInfo.mrd:MD_Distribution.mrd:distributionFormat.mrd:MD_Format.mrd:name.cit:CI_Citation.cit:title.gco:CharacterString',
      source:
        'mdb:contact.cit:CI_Responsibility.cit:party.cit:CI_Organisation.cit:name.gco:CharacterString',
    } : {
      title:
        'gmd:identificationInfo.gmd:MD_DataIdentification.gmd:citation.gmd:CI_Citation.gmd:title.gco:CharacterString',
      description:
        'gmd:identificationInfo.gmd:MD_DataIdentification.gmd:abstract.gco:CharacterString',
      scale:
        'gmd:identificationInfo.gmd:MD_DataIdentification.gmd:spatialResolution.gmd:MD_Resolution.gmd:equivalentScale.gmd:MD_RepresentativeFraction.gmd:denominator.gco:Integer',
      date: {
        type:
          'gmd:identificationInfo.gmd:MD_DataIdentification.gmd:citation.gmd:CI_Citation.gmd:date.gmd:CI_Date.gmd:dateType.gmd:CI_DateTypeCode.@attributes.codeListValue',
        dateString:
          'gmd:identificationInfo.gmd:MD_DataIdentification.gmd:citation.gmd:CI_Citation.gmd:date.gmd:CI_Date.gmd:date.gco:CharacterString',
        dateDateTime:
          'gmd:identificationInfo.gmd:MD_DataIdentification.gmd:citation.gmd:CI_Citation.gmd:date.gmd:CI_Date.gmd:date.gco:DateTime',
        dateDate:
          'gmd:identificationInfo.gmd:MD_DataIdentification.gmd:citation.gmd:CI_Citation.gmd:date.gmd:CI_Date.gmd:date.gco:Date',
      },
      serviceLink:
        'gmd:distributionInfo.gmd:MD_Distribution.gmd:transferOptions.gmd:MD_DigitalTransferOptions.gmd:onLine.0.gmd:CI_OnlineResource.gmd:linkage.gmd:URL',
      serviceType:
        'gmd:distributionInfo.gmd:MD_Distribution.gmd:distributionFormat.gmd:MD_Format.gmd:nameFormat.gco:CharacterString',
      source:
        'gmd:contact.gmd:CI_ResponsibleParty.gmd:organisationName.gco:CharacterString',
    };

    const getMaskDate = (paramMetadataPath) => {
      if(dot.pick(paramMetadataPath.date.dateDateTime, layerMetadata)) {              
        return formatDate(dot.pick(paramMetadataPath.date.dateDateTime, layerMetadata));
      }else if(dot.pick(paramMetadataPath.date.dateString, layerMetadata)){      
        return dot.pick(paramMetadataPath.date.dateString, layerMetadata)
      }else{
      return dot.pick(paramMetadataPath.date.dateDate, layerMetadata) ? formatDate(dot.pick(paramMetadataPath.date.dateDate, layerMetadata), true) : '';
      }
    }

    const filterDateForPortuguese = (paramDateType) => {      
      if(paramDateType === 'creation') {
        return 'Criado';
      }else if(paramDateType === 'publication'){
        return 'Publicado'
      }else {
        return paramDateType === 'revision' ? 'Atualizado' : '';
      }
    }

    title = dot.pick(metadataPath.title, layerMetadata)
    ? dot.pick(metadataPath.title, layerMetadata)
    : '';
    description = dot.pick(metadataPath.description, layerMetadata)
    ? dot.pick(metadataPath.description, layerMetadata)
    : '';
    scale = dot.pick(metadataPath.scale, layerMetadata)
    ? dot.pick(metadataPath.scale, layerMetadata)
    : '';

    date = getMaskDate(metadataPath)
   
    dateType = dot.pick(metadataPath.date.type, layerMetadata)
      ? dot.pick(metadataPath.date.type, layerMetadata)
      : '';
    source = dot.pick(metadataPath.source, layerMetadata)
      ? dot.pick(metadataPath.source, layerMetadata)
      : '';        

    setMetadataInfo({
      title,
      description,
      scale,
      date: {
        type:
          filterDateForPortuguese(dateType),
        date,
      },
      metadataLink,
      serviceLink,
      source,
    });

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [layerMetadata, hasMetadata]);

  useEffect(() => {

    if(hasMetadata === false && isLoadingData){
      const resumeData = formattedTextResume(layerResume);
      
      setMetadataInfo((prev) => ({
        ...prev,
        title: resumeData?.title || '',
        description: resumeData?.description || '',
        scale: resumeData?.scale || '',
        date: {
          type: resumeData?.date ? 'Publicado' : '',
          date: resumeData?.date || '',
        },
        source: resumeData?.source || '',
      }));

      setIsLoadingData(false);
    } else if(hasMetadata === true && isLoadingData) {
      setIsLoadingData(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasMetadata])

  const formatDate = (dateString, utc = true) => {
    const date = new Date(dateString);
    const day = `${utc ? date.getUTCDate() : date.getDate()}`;
    const month = `${utc ? date.getUTCMonth() + 1 : date.getMonth() + 1}`;
    const year = `${utc ? date.getUTCFullYear() : date.getFullYear()}`;
    return `${day.padStart(2, '0')}/${month.padStart(2, '0')}/${year}`;
  };

  const formattedTextResume = (texto) => {
    if (!texto || typeof texto !== 'string') return {};

    const fonteMatch = texto.match(/Fonte:\s*([\s\S]*?)(?=Escala:|Publicado:|$)/);
    const escalaMatch = texto.match(/Escala:\s*([\s\S]*?)(?=Publicado:|$)/);
    const dataMatch = texto.match(/Publicado:\s*([\s\S]*)/);

    // Pega o índice do primeiro campo conhecido
    const indices = [
      texto.indexOf('Fonte:'),
      texto.indexOf('Escala:'),
      texto.indexOf('Publicado:')
    ].filter((i) => i !== -1);

    const menorIndice = indices.length > 0 ? Math.min(...indices) : texto.length;
    const desc = texto.slice(0, menorIndice).trim();

    return {
      title: layerName || null,
      description: desc || null,
      source: fonteMatch ? fonteMatch[1].trim() : null,
      scale: escalaMatch ? escalaMatch[1].trim() : null,
      date: dataMatch ? dataMatch[1].trim() : null
    };
  }

  const { enqueueSnackbar } = useSnackbar();

  const MetadataItem = ({ title, value, children }) => {

    const attrChildren = (paramValue, paramChildren) => {
      if(paramChildren){
        return paramChildren;
      }else{
        return paramValue;
      }    
    }
    return (
      <MetadataItemWrap className="item">
        <p>{title}</p>
        {value ? (
          <p className="attrValue">{attrChildren(value, children)}</p>
        ) : (
          <Skeleton color="#E6E5E5" marginTop="19px" loading={isLoadingData} />
        )}
      </MetadataItemWrap>
    );
  };

  const serviceLinkRef = useRef();
  const WMSServiceLinkRef = useRef();
  const WFSServiceLinkRef = useRef();

  const lengthDescriptionMetadataInfo = (paramMetadataInfo) => {
    if(paramMetadataInfo.description.length > 795) {
      return '[...]'
    }else{
      return '';
    }
  }
  /**
   * Estitura do componente de visualização simplificada de metadados de uma camada.
   */
  return (
    <Container isClosed={!isShowing} onlyContent={onlyContent}>
      {!onlyContent && (
        <button onClick={() => setIsShowing(!isShowing)}>
          Metadados
          <span>
           <Icons i="all-arrow" />
          </span>
        </button>
      )}
      <PanelWrapper maxHeight={isShowing ? '500px' : '0'}>
        <MetadataTitle onlyContent={onlyContent}>
          {metadataInfo.title ? (
            <h3>{metadataInfo.title}</h3>
          ) : (
            <Skeleton
              height="15.9px"
              width="153.4px"
              borderRadius="3px"
              loading={isLoadingData}
            />
          )}
        </MetadataTitle>
        <MetadataDescription descriptionOverflow={descriptionOverflow}>
          {metadataInfo.description ? (
            <p>{`${metadataInfo.description.substr(0, 795)}${lengthDescriptionMetadataInfo(metadataInfo)}`}</p>
          ) : (
            <>
              <Skeleton
                marginTop={onlyContent && '8px'}
                loading={isLoadingData}
              />
              <Skeleton
                marginTop={onlyContent && '8px'}
                loading={isLoadingData}
              />
              <Skeleton
                marginTop={onlyContent && '8px'}
                loading={isLoadingData}
              />
              <Skeleton
                marginTop={onlyContent && '8px'}
                loading={isLoadingData}
              />
            </>
          )}
          <div className="item">
            <p>
              Fonte:{' '}
              {metadataInfo.source ? (
                metadataInfo.source
              ) : (
                <span>
                  <Skeleton
                    style={{ display: 'inline-block' }}
                    width="100px"
                    loading={isLoadingData}
                  />
                </span>
              )}
            </p>
          </div>
        </MetadataDescription>
        <MetadataAtributes>
          <MetadataItem
            title="Escala"
            value={metadataInfo.scale ? `1:${metadataInfo.scale}` : null}
          />
          <MetadataItem
            title={metadataInfo.date.type ? metadataInfo.date.type : 'Data'}
            value={metadataInfo.date.date}
          />
          <MetadataItem title="Metadados" value={metadataInfo.metadataLink}>
            <a
              href={metadataInfo.metadataLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Icon i="map-link" />
            </a>
          </MetadataItem>
          {
            /**
             * Para camadas externas, verifica se pode
             * disponibilizar link do seu próprio serviço
             */
            canShowLinkService && (
              <MetadataItem title="Serviço" value={metadataInfo.serviceLink}>
                <textarea ref={serviceLinkRef}>
                  {metadataInfo.serviceLink}
                </textarea>
                <button
                  type="button"
                  onClick={() => {
                    serviceLinkRef.current.select();
                    serviceLinkRef.current.setSelectionRange(0, 99999);
                    document.execCommand('copy');
                    enqueueSnackbar({
                      message: 'Link copiado',
                      variant: 'success',
                    });
                  }}
                >
                  <Icon i="map-copy" />
                </button>
              </MetadataItem>
            )
          }
          {
            /**
             * Para camadas internas, verifica se o mesmo possui
             * configurado no serviço (GeoServer) as opções de WMS e WFS
             */
            (avaliableWMSServiceLink || avaliableWFSServiceLink) && (
              <MetadataItem title="Serviço" value={metadataInfo.serviceLink}>
                {avaliableWMSServiceLink && (
                  <button
                    type="button"
                    onClick={() => {
                      WMSServiceLinkRef.current.select();
                      WMSServiceLinkRef.current.setSelectionRange(0, 99999);
                      document.execCommand('copy');
                      enqueueSnackbar({
                        message: 'Link copiado',
                        variant: 'success',
                      });
                    }}
                  >
                    WMS
                    <textarea ref={WMSServiceLinkRef}>
                      {avaliableWMSServiceLink}
                    </textarea>
                  </button>
                )}
                {
                  /**
                   * Verifica a disponibilidade de ambos os serviços (WMS e WFS)
                   * da camada estão disponíveis para adicionar separador entre
                   * os labels
                   */
                  avaliableWMSServiceLink && avaliableWFSServiceLink && (
                    <span>&nbsp;/&nbsp;</span>
                  )
                }
                {avaliableWFSServiceLink && (
                  <button
                    type="button"
                    onClick={() => {
                      WFSServiceLinkRef.current.select();
                      WFSServiceLinkRef.current.setSelectionRange(0, 99999);
                      document.execCommand('copy');
                      enqueueSnackbar({
                        message: 'Link copiado',
                        variant: 'success',
                      });
                    }}
                  >
                    WFS
                    <textarea ref={WFSServiceLinkRef}>
                      {avaliableWFSServiceLink}
                    </textarea>
                  </button>
                )}
              </MetadataItem>
            )
          }
        </MetadataAtributes>
        {!onlyContent && <hr />}
      </PanelWrapper>
    </Container>
  );
};

MetadataView.propTypes = {
  /** Indicado de existencia de metadado antes mesmo de ser carregado */
  hasMetadata: PropTypes.bool,
  /** Objeto contendo os XML dos metadados convertido em JSON  */
  layerMetadata: PropTypes.object,
  /** Link de acesso ao metadado no portal */
  metadataLink: PropTypes.string,
  /** Tipo do metadado utilizado pela camada */
  metadataXmlType: PropTypes.string,
  /** Link do serviço */
  serviceLink: PropTypes.string,
  /** Define se o Header retrátil deve ser exibido */
  onlyContent: PropTypes.bool,
  /** Define o `max-height` da seção de descrição dos metadados, para utilização do overflow */
  descriptionOverflow: PropTypes.string,
};

export default MetadataView;
